module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "mt-0",
    attrs: {
      "dense": "",
      "subheader": ""
    }
  }, [(_vm.withInlineControls) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "blue": "",
      "absolute": "",
      "right": ""
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), _c('v-subheader', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._l((_vm.appointment.codes), function(code, index) {
    return _c('v-list-tile', {
      key: code.id,
      attrs: {
        "disabled": _vm.deleting.indexOf(code.id) !== -1
      }
    }, [(_vm.withDelete) ? _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.prepareToDelete(code, index)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n        " + _vm._s(code.icd10) + ". " + _vm._s(code.process) + "\n      ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n      " + _vm._s(_vm.formatCurrency(code.currency, code.price)) + "\n    ")])], 1)
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": 300
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        " + _vm._s(_vm.$t('dialog.delete.title')) + "\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.deleteRequest.loading,
      "color": "error"
    },
    on: {
      "click": _vm.deleteCode
    }
  }, [_vm._v("Delete")])], 1)], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-815d5bca","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/statement/AppointmentCodeList.vue
// module id = 1486
// module chunks = 9